import React from "react";
import { useParams } from "react-router-dom";
import TitleContainer from "../../components/common/Layout/TitleContainer";
import { LotteryMain } from "../../components/NewYear/Lottery";

const LotteryPage = () => {
  const { eventId } = useParams();

  return (
    <>
      <TitleContainer
        title="추첨 이벤트"
        description="청약하고 추첨에 참여하세요!"
        style={{ "bkg-grey-ultralight": true }}
      />
      <div className="section-block clearfix pt-0 pb-0 bkg-grey-ultralight">
        <div className="row">
          <div className="column width-10 offset-1 content-inner">
            <LotteryMain eventId={eventId} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LotteryPage;
